module.exports = __webpack_public_path__ + "static/media/26-js.710221c4.svg";